module.exports = __webpack_public_path__ + "img/maan_main.e3dc42c4.png";